import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  marginBottom: '$4',
  fullWidth: true,
});
